import { render, staticRenderFns } from "./MoonPhaseQuiz.vue?vue&type=template&id=e5972e82&scoped=true&lang=pug&"
import script from "./MoonPhaseQuiz.vue?vue&type=script&lang=js&"
export * from "./MoonPhaseQuiz.vue?vue&type=script&lang=js&"
import style0 from "./MoonPhaseQuiz.vue?vue&type=style&index=0&id=e5972e82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5972e82",
  null
  
)

component.options.__file = "MoonPhaseQuiz.vue"
export default component.exports